export default {
    PtSelectLanguage: {
        language: '語言',
    },
};
